if (!customElements.get('currency-selector')) {
  customElements.define(
    'currency-selector',
    class CurrencySelector extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.cs-trigger');
        this.modal = this.querySelector('.cs-modal');
        this.dialog = this.querySelector('.cs-dialog');
        this.overlay = this.querySelector('.cs-overlay');
        this.closeEls = this.querySelectorAll('[data-cs-close]');
        this.languageSelector = this.querySelector('.cs-language-header');
        this.currencySelector = this.querySelector('.cs-currency-header');
        this.currencyOptions = this.querySelectorAll('button.cs-currency');
        this.langOptions = this.querySelectorAll('button.cs-lang');
        this.langInput = this.querySelector('input[name="language_code"]');
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.form = this.querySelector('form');
        this.submitting = false;
        this.currentCurrency;
        this.lastGtagEventAt = 0;

        this.querySelector('.cs-currency-header')?.addEventListener('click', () => {
          this.displayLanguagesHandler({ show: false });
        });
        this.currencyOptions.forEach((option) => {
          option.getAttribute('aria-current') === 'true' && (this.currentCurrency = option);
          option.addEventListener('click', this.currencyClickHandler.bind(this));
        });
        this.langOptions.forEach((option) => {
          option.addEventListener('click', this.languageSubmitHandler.bind(this));
        });
      }

      connectedCallback() {
        // Duration from data attribute (default: 350ms)
        const duration = parseInt(this.dataset.duration, 10) || 350;
        this.dialog.style.setProperty('--cs-duration', `${duration}ms`);

        const pdpCurrencySelector = document.querySelector('.pdp-currency-selector');

        this.trigger?.addEventListener('click', () => {
          const wasOpen = this.modal.classList.contains('is-active');
          this.open();
          if (!wasOpen && pdpCurrencySelector && pdpCurrencySelector.contains(this)) {
            this.sendGtagEvent();
          }
        });
        this.closeEls.forEach((el) => el.addEventListener('click', () => this.close()));

        // ESC key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal.classList.contains('is-active')) this.close();
        });
      }

      sendGtagEvent() {
        if (typeof gtag !== 'function') return;
        const now = Date.now();
        if (now - this.lastGtagEventAt < 3000) return;
        this.lastGtagEventAt = now;
        gtag('event', 'pdp_currency_selector', {
          event_category: 'pdp',
          event_label: 'pdp_currency_selector',
          event_type: 'click',
        });
      }

      currencyClickHandler(event) {
        this.countryInput.value = event.currentTarget.value;
        if (event.currentTarget.dataset.language === 'true') {
          this.languageClickHandler(event.currentTarget);
          return;
        }
        this.close();
        this.form.requestSubmit();
      }

      displayLanguagesHandler({ show = true, isoCode = null }) {
        if (show) {
          this.languageSelector.classList.replace('cs-hidden', 'active');
        } else {
          this.languageSelector.classList.replace('active', 'cs-hidden');
          this.currencySelector.querySelector('span').textContent =
            this.currentCurrency.dataset.symbol;
        }

        this.currencySelector.classList.toggle('active', !show);

        Array.from(this.langOptions)
          .filter((option) => {
            const locale = option.dataset.currency;
            if (isoCode) {
              return locale.includes(isoCode);
            } else {
              return true;
            }
          })
          .forEach((option) => {
            option.parentElement.classList.toggle('cs-hidden', !show);
          });
        Array.from(this.currencyOptions).forEach((option) => {
          option.parentElement.classList.toggle('cs-hidden', show);
        });
      }

      languageSubmitHandler(event) {
        const lang = event.currentTarget.value;

        if (this.submitting) return;
        this.submitting = true;
        this.langInput.value = lang;
        this.close();
        this.form.requestSubmit();
      }

      languageClickHandler(event) {
        this.currencySelector.querySelector('span').textContent = event.dataset.symbol;
        const code = event.value;
        this.displayLanguagesHandler({ isoCode: code });
      }

      open() {
        this.originalParent = this.originalParent || this.modal.parentElement;
        document.body.appendChild(this.modal);

        this.modal.hidden = false;
        this.modal.classList.add('is-active');
        window.scrollLock?.lock();

        // trigger animation next frame
        requestAnimationFrame(() => {
          this.dialog.classList.add('enter');
        });
      }

      close() {
        this.dialog.classList.remove('enter');
        this.dialog.classList.add('leave');
        window.scrollLock?.unlock();

        // Use the duration from the CSS var for sync
        const duration =
          parseInt(getComputedStyle(this.dialog).getPropertyValue('--cs-duration')) || 350;

        setTimeout(() => {
          this.modal.classList.remove('is-active');
          this.modal.hidden = true;
          this.dialog.classList.remove('leave');
          this.displayLanguagesHandler({ show: false });
          this.submitting = false;

          this.originalParent.appendChild(this.modal);
        }, duration);
      }
    },
  );
}
